import React from 'react';
import Joyride from 'react-joyride';

import { locale, styles } from './appTour.config';
import useAppTour from '../../hooks/useAppTour';

const AppTour = () => {
  const { steps, run, stepIndex, handleJoyrideCallback, tourKey, isMobile } = useAppTour();

  return (
    <Joyride
      key={tourKey}
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      continuous={true}
      showSkipButton={true}
      showProgress={true}
      disableBeacon={true}
      spotlightClicks={false}
      disableScrollParentFix={isMobile}
      floaterProps={{
        options: { strategy: 'fixed' },
      }}
      callback={handleJoyrideCallback}
      styles={styles}
      locale={locale}
    />
  );
};

export default AppTour;
